import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  loading: false,
  resData: {
    courses: [],
    meta: {},
  },
  projects: [],
  courseUnderProject: [],
  submitLoading: false,
  courseDescription: {
    data: [],
    loading: false,
  },
  courseCard: {
    loading: false,
    data: [],
    meta: {},
  },
  courseDetails: {
    data: [],
    loading: false,
  },
};

export const getAllCourses = createAsyncThunk('courseSlice/getAllCourses', async (paginationDetails) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/courses/2?sortBy=courseName&sortDirection=asc&page=${paginationDetails?.pageNum}&limit=${
      paginationDetails?.gridSize
    }&search=${encodeURIComponent(paginationDetails?.search)}&skillx=${paginationDetails?.skillx}`,
  });
  return res;
});

export const getAllProjects = createAsyncThunk('courseSlice/getAllProjects', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cr-pre-data/getProjects`,
  });
  return res;
});

export const createCourse = createAsyncThunk('courseSlice/createCourse', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/courses`,
    data: data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
  return res;
});

export const deleteCourse = createAsyncThunk('courseSlice/deleteCourse', async (id) => {
  const res = await apiRequest({
    method: 'delete',
    url: `general/courses/${id}`,
  });
  return res;
});

export const updateCourse = createAsyncThunk('courseSlice/updateCourse', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `general/courses/${data.id}`,
    data: data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
  return res;
});

export const getCourseUnderProject = createAsyncThunk('courseSlice/getCourseUnderProject', async (id) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/courses-advanced/courses-under-projects?projectId=${id}`,
  });
  return res;
});

export const postCourseDescription = createAsyncThunk('courseSlice/postCourseDescription', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/courses-advanced/more-details`,
    data,
  });
  return res;
});

export const putCourseDescription = createAsyncThunk('courseSlice/putCourseDescription', async ({ id, data }) => {
  const res = await apiRequest({
    method: 'put',
    url: `general/courses-advanced/update-more-details/${id}`,
    data,
  });
  return res;
});

export const getCourseDescription = createAsyncThunk('courseSlice/getCourseDescription', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `general/courses-advanced/get-all-course-available-details?${searchParams}`,
  });
  return res;
});

export const getCourseCards = createAsyncThunk('courseSlice/getCourseCards', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `general/courses-advanced/get-all-course-available-cards?${searchParams}`,
  });
  return res;
});

export const getCourseDetails = createAsyncThunk('courseSlice/getCourseDetails', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `general/courses-advanced/get-all-course-available-details?${searchParams}`,
  });
  return res;
});

const courseSlice = createSlice({
  name: 'courseSlice',
  initialState,
  reducers: {
    clearCourseState: (state, action) => {
      const { stateName, clearValue } = action.payload;
      state[stateName] = clearValue;
    },
  },

  extraReducers: (builder) => {
    //..................GETING ALL AVAILABLE COURSES................
    builder.addCase(getAllCourses.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAllCourses.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        resData: {
          ...state.resData,
          courses: action.payload?.data,
          meta: action.payload?.meta,
        },
      };
    });

    //..................GETING ALL AVAILABLE PROJECTS................
    builder.addCase(getAllProjects.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAllProjects.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        projects: action.payload?.data?.projects,
      };
    });

    //..................CREATE A COURSE................
    builder.addCase(createCourse.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(createCourse.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

    //..................DELETE A COURSE................
    builder.addCase(deleteCourse.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(deleteCourse.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

    //..................UPDATE A COURSE................
    builder.addCase(updateCourse.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(updateCourse.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // get Course Under project
    builder.addCase(getCourseUnderProject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCourseUnderProject.fulfilled, (state, action) => {
      state.loading = false;
      state.courseUnderProject = action.payload?.data;
    });

    // post  Course Description
    builder.addCase(postCourseDescription.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(postCourseDescription.fulfilled, (state, action) => {
      state.submitLoading = false;
    });

    // put Course Description
    builder.addCase(putCourseDescription.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(putCourseDescription.fulfilled, (state, action) => {
      state.submitLoading = false;
    });

    // get Course Description
    builder.addCase(getCourseDescription.pending, (state) => {
      state.courseDescription.loading = true;
    });
    builder.addCase(getCourseDescription.fulfilled, (state, action) => {
      state.courseDescription.loading = false;
      state.courseDescription.data = action.payload?.data;
    });

    // get Course Cards
    builder.addCase(getCourseCards.pending, (state) => {
      state.courseCard.loading = true;
    });
    builder.addCase(getCourseCards.fulfilled, (state, action) => {
      state.courseCard.loading = false;
      state.courseCard.data = action.payload?.data;
      state.courseCard.meta = action.payload?.meta;
    });

    // get Course Cards
    builder.addCase(getCourseDetails.pending, (state) => {
      state.courseDetails.loading = true;
    });
    builder.addCase(getCourseDetails.fulfilled, (state, action) => {
      state.courseDetails.loading = false;
      state.courseDetails.data = action.payload?.data;
    });
  },
});

export default courseSlice.reducer;

export const { clearCourseState } = courseSlice.actions;
